import { FeatureFlag, type FeatureFlagKeyValue } from '@insio/shared-types';

/**
 * Feature flag keys the web app fetches through the featureFlags query.
 * Add a new key to `FeatureFlag` in `@insio/shared-types` first, with its metadata.
 */
export const FeatureFlagKey = {
  PROCUREMENT: FeatureFlag.PROCUREMENT,
  CONTRACTS: FeatureFlag.CONTRACTS,
  /** The upload offers the format only where it is read. */
  BANK_STATEMENTS_GPC: FeatureFlag.BANK_STATEMENTS_GPC,
  PAYMENTS: FeatureFlag.PAYMENTS
} as const satisfies Record<string, FeatureFlagKeyValue>;

export type FeatureFlagKey = (typeof FeatureFlagKey)[keyof typeof FeatureFlagKey];

export const FEATURE_FLAG_KEYS: string[] = Object.values(FeatureFlagKey);
